import styled from "styled-components";
import BuildingSystemRefinementList from "./BuildingSystemRefinementList";
import CheckBoxRefinementList from './CheckBoxRefinementList';
import ToggleButtonRefinement from './ToggleButtonRefinement';
import {useTranslation} from "react-i18next";


const ItemLabel = styled.span`
  margin-left: 8px;
  font-family: Open Sans, sans-serif;;
  font-size: 16px;
  font-weight: ${(props) => (props.checked ? 600 : "normal")};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: normal;
  text-align: left;
  color: #2c271c;
}`;

const ItemCount = styled.span`
border: none;
font-family: Open Sans, sans-serif;;
font-size: 12px;
font-weight: 600;
font-stretch: normal;
font-style: normal;
line-height: 1.42;
letter-spacing: normal;
text-align: center;
color: #2c271c;
text-align: center;
text-decoration: none;
display: inline-block;
padding: 1px 4px 1px;
border-radius: 10px;
background-color: #e6e6e6;
    margin-left: 5px;
}`;

export default function BuildingSystemFilter() {

  const { t, i18n } = useTranslation();

    return (
      <div>
      <BuildingSystemRefinementList operator="or" attribute="building_system_name" values={[
        { label: t('MassTimber'), value: t('MassTimber') },
        { label: t('LightFrame'), value: t('LightFrame') },
      ]} />
      <div style={{paddingTop:'20px'}}>
        <ToggleButtonRefinement attribute="is_unclaimed" label={t('Unclaimed.Projects')} defaultChecked={true} value={false} />
      </div>
      <div className="form-default" style={{paddingTop:'20px'}}>
      <div className="form__row">
        <div className="form__group">
          <label className="form__label" htmlFor="material-exp">{t('Secondary.Systems')}</label>
          <CheckBoxRefinementList operator="or" attribute="secondary_building_system_names" initialFacets={window.all_sub_building_systems} />
        </div>
      </div>
      </div>
      </div>

    );
}
